<ul class="nav nav-tabs">
  <li class="nav-item" *ngFor="let tab of model.tabs">
    <a (click)="setTab(tab)" class="nav-link" [ngClass]="{ 'active': model.currentTab === tab }" [kitText]="tab.text"></a>
  </li>
</ul>

<div class="tab-content" [kitContainer]="model.currentTab?.content">
</div>
